'use strict'

angular.module('shiftTraderApp')
  .controller('NewFeaturesModalCtrl', function ($uibModalInstance, params) {
    var vm = this

    vm.me = params.me

    var close = function () {
      vm.me.$finishTour('newfeature-payrates-tour')
        .then(function () {
          $uibModalInstance.close()
        }, function () {
          $uibModalInstance.close()
        })
    }

    vm.close = close
    vm.done = close
  })
